import { createContext } from "react";
export const designSixPagecounter = createContext(null);
export const designSixMainCategories = createContext([]);
export const designSixFavoriteInputsArray = createContext([]);
export const designSixWishlistItemsArray = createContext([]);